import { Component, Mixins } from 'vue-property-decorator'
import { Bar } from 'vue-chartjs'
import {
  Chart as ChartJS,
  ChartData,
  ChartOptions,
  TooltipItem,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  Colors
} from 'chart.js'
import WidgetMixin from '../../mixins/WidgetMixin'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, Colors)

@Component({
  components: {
    Bar
  }
})
export default class WidgetBar extends Mixins(WidgetMixin) {
  get chartData (): ChartData {
    const datas = this.dashboardData as KwixeoDashboard.BarDatas
    const datasets = [
      {
        data: datas.map(data => data[(this.value.params as KwixeoDashboard.BarParams).value]),
        backgroundColor: this.dataColors
      }
    ]

    if (this.computedCompare) {
      const datasCompare = this.dashboardDataCompare as KwixeoDashboard.BarDatas
      datasets.push({
        data: datasCompare.map(data => data[(this.value.params as KwixeoDashboard.BarParams).value]),
        backgroundColor: this.dataColors.map(color => this.lightenColor(color))
      })
    }

    return {
      labels: this.labels,
      datasets
    }
  }

  get chartOptions (): ChartOptions {
    return {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        y: {
          ticks: {
            maxTicksLimit: 8,
            callback: (value: number|string): number|string => {
              let number: number|string = this.showNumber(value, 2) as number
              if (number >= 1000) {
                number = (number / 1000) + 'k'
              }
              return number
            }
          }
        },
        x: {
          grid: {
            display: false
          },
          ticks: {
            autoSkip: false,
            callback: (index: number|string): string => {
              const label = this.labels[index as number]
              if (label === null || label === undefined) {
                return this.$t('dashboard.widget.unknown') as string
              }
              return label.length > 10 ? label.substring(0, 10) + '...' : label
            }
          }
        }
      },
      plugins: {
        legend: {
          display: false
        },
        tooltip: {
          mode : 'index',
          yAlign: 'bottom',
          boxPadding: 5,
          callbacks: {
            label: (tooltipItem: TooltipItem<'bar'>): string | string[] | void => {
              let compareValue: number|null = null
              if (this.computedCompare && tooltipItem.datasetIndex === 0) {
                compareValue = tooltipItem.chart.data.datasets[tooltipItem.datasetIndex+1].data[tooltipItem.dataIndex] as number
              }

              return this.tooltipLabel(
                Number(tooltipItem.raw),
                tooltipItem.dataset.data as number[],
                compareValue
              )
            }
          }
        }
      }
    }
  }
}
